export const INTEGRATIONS_API_BASE =
  'https://266s5nz9rc.execute-api.us-west-2.amazonaws.com/prod';

export const JN_CONFIG_API_BASE =
  'https://wn21jsz8ne.execute-api.us-west-2.amazonaws.com/prod/integrations/jobnimbus/config';

export const ACCULYNX_CONFIG_API_BASE =
  'https://wn21jsz8ne.execute-api.us-west-2.amazonaws.com/prod/integrations/acculynx/config';

export const HUBSPOT_CONFIG_API_BASE =
  'https://wn21jsz8ne.execute-api.us-west-2.amazonaws.com/prod/integrations/hubspot/config';

export const HUBSPOT_OAUTH_URL_API =
  'https://wn21jsz8ne.execute-api.us-west-2.amazonaws.com/prod/integrations/hubspot/oauth-url';

export const HUBSPOT_PROPERTIES_API =
  'https://wn21jsz8ne.execute-api.us-west-2.amazonaws.com/prod/integrations/hubspot/properties';
